import { render, staticRenderFns } from "./CustomAlert.vue?vue&type=template&id=01327ff2&scoped=true"
import script from "./CustomAlert.vue?vue&type=script&lang=js"
export * from "./CustomAlert.vue?vue&type=script&lang=js"
import style0 from "./CustomAlert.vue?vue&type=style&index=0&id=01327ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01327ff2",
  null
  
)

export default component.exports